package com.parmartechnologies.business.feature.business.viewModel

import com.parmartechnologies.core.feature.address.model.Address
import com.parmartechnologies.core.feature.address.model.LocationCoordinate
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.feature.business.network.CreateBusinessRequest
import com.parmartechnologies.core.feature.business.network.FindBusinessRequest
import com.parmartechnologies.core.feature.business.network.FindNearbyBusinessRequest
import com.parmartechnologies.core.feature.business.network.RetrieveBusinessRequest
import com.parmartechnologies.core.feature.business.network.RetrieveSingleBusinessRequest
import com.parmartechnologies.core.feature.business.network.UpdateBusinessRequest
import com.parmartechnologies.core.feature.businessType.model.BusinessType
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.business.feature.business.network.BusinessNetwork
import com.parmartechnologies.business.feature.business.repository.BusinessRepository
import com.parmartechnologies.business.feature.businessConfig.viewModel.BusinessConfigViewModel
import com.parmartechnologies.business.feature.businessType.viewModel.BusinessTypeViewModel
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.country.CountryCode
import com.parmartechnologies.core.feature.sync.BusinessAnalytics
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.constant.KeyConstant
import com.parmartechnologies.storage.constant.KeyConstant.Companion.UserID
import com.parmartechnologies.storage.store.UserDefaults
import com.parmartechnologies.storage.table.business.BusinessDatabaseTable
import com.parmartechnologies.ui.core.mediaFile.viewModel.MediaFileViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.json.Json
import org.jetbrains.compose.resources.ExperimentalResourceApi
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

class BusinessViewModel :
    AppViewModel() {
    val json = Json {
        encodeDefaults = true
        ignoreUnknownKeys = true
        isLenient = true
    }
    val repository: BusinessRepository = BusinessHandler.shared().repository
    val searchQuery: StateFlow<String>
        get() = repository.searchQuery
    val analytics: StateFlow<ArrayList<BusinessAnalytics>>
        get() = repository.analytics

    val myBusiness: StateFlow<Business>
        get() = repository.myBusiness

    val selectedBusiness: StateFlow<Business>
        get() = repository.selectedBusiness

    val allBusiness: StateFlow<List<Business>>
        get() = repository.allBusiness


    val createBusiness: StateFlow<Business>
        get() = repository.createBusiness

    val addBusinessConnectionSearchResult: StateFlow<List<Business>>
        get() = repository.addBusinessConnectionSearchResult

    val allNearbyBusiness: StateFlow<List<Business>>
        get() = repository.nearbyBusinessSearchResult

    override fun changeSearchQuery(value: String) {
        scope.launch {
            repository.searchQueryState.emit(value)
        }
        performSearch(value)
    }

    override fun performSearch(value: String) {
        if (value.isEmpty()) {
            loadBusiness()
        } else {
//            DatabaseTable().search(
//                value
//            ) { data:List<Business> ->
//                scope.launch {
//                    repository.allBusinessLiveData.emit(data)
//                    repository.nearbyBusinessSearchResultState.emit(data)
//                    repository.nearbyBusinessState.emit(data)
//                }
//            }
        }
    }

    @OptIn(ExperimentalTime::class)
    fun setLocationForNewBusinessAddress(locationCoordinate: LocationCoordinate?) {
        scope.launch {
            val businessToUpdate = createBusiness.value
            businessToUpdate.createdAt = Clock.System.now().toLocalDateTime(TimeZone.UTC).toString()
            repository.createBusinessState.emit(Business())
            delay(500)
            businessToUpdate.Address.Location =
                LocationCoordinate()
            scope.launch {
                val newAddress = businessToUpdate.Address
                newAddress.Location = LocationCoordinate()
                businessToUpdate.Address = newAddress
                repository.createBusinessState.emit(businessToUpdate)
            }
        }
    }

    fun setNameForNewBusiness(name: String) {
        val businessToUpdate = createBusiness.value
        businessToUpdate.Name = name
        scope.launch {
            repository.createBusinessState.emit(businessToUpdate)
        }
    }

    fun setEmailForNewBusiness(email: String) {
        val businessToUpdate = createBusiness.value
        businessToUpdate.EmailID = email
        scope.launch {
            repository.createBusinessState.emit(businessToUpdate)
        }
    }

    fun setNoteOneForNewBusiness(noteOne: String) {
        val businessToUpdate = createBusiness.value
        businessToUpdate.noteOne = noteOne
        scope.launch {
            repository.createBusinessState.emit(businessToUpdate)
        }
    }

    fun setNoteTwoForNewBusiness(noteTwo: String) {
        val businessToUpdate = createBusiness.value
        businessToUpdate.noteOne = noteTwo
        scope.launch {
            repository.createBusinessState.emit(businessToUpdate)
        }
    }

    fun setMobileForNewBusiness(mobile: String) {
        val businessToUpdate = createBusiness.value
        businessToUpdate.MobileNumber = mobile
        scope.launch {
            repository.createBusinessState.emit(businessToUpdate)
        }
    }


    fun setDialCodeForNewBusiness(country: CountryCode) {
        val businessToUpdate = createBusiness.value
        businessToUpdate.DialCode = country.countryPhoneCode
        businessToUpdate.CountryCode = country.countryCode
        scope.launch {
            repository.createBusinessState.emit(businessToUpdate)
        }
    }


    fun loadBusiness() {
        val user = AuthHandler.shared().repository.authLiveData.value
        BusinessTypeViewModel().load()
        val request = RetrieveBusinessRequest(
            UserID = user._id,
            MobileNumber = user.MobileNumber,
            dialCode = user.DialCode
        )
        startLoading()
        BusinessNetwork().retrieve(request) {
            stopLoading()
            if (!it?.payload.isNullOrEmpty()) {
                DatabaseCollection().insertAll(
                    it.payload,
                    serializer = Business.serializer()
                )
                scope.launch {
                    repository.allBusinessLiveData.emit(it.payload)
                }
            } else {
                loadBusinessFromDatabase()
                stopLoading()
            }
        }
    }

    private fun loadBusinessFromDatabase() {
        val user = AuthHandler.shared().repository.authLiveData.value
        DatabaseCollection().findAllByUserId(
            user._id,
            serializer = Business.serializer()
        ) { businesses: List<Business> ->
            scope.launch {
                repository.allBusinessLiveData.emit(businesses)
            }
        }
    }

    fun getBusinessById(id: String, callBack: (Business?) -> Unit) {
        retrieveFromDb(id, callBack)
        val request = RetrieveSingleBusinessRequest(
            id
        )
        startLoading()
        BusinessNetwork().retrieveSingleBusiness(request) {
            stopLoading()
            if (!it?.payload?._id.isNullOrEmpty()) {
                callBack(it.payload)
                DatabaseCollection().insert(data = it.payload, Business.serializer())
                retrieveFromDb(id, callBack)
                BusinessDatabaseTable().insert(it.payload) {
                    retrieveFromDb(id, callBack)
                }
            } else {
                callBack(null)
            }
        }
    }

    fun loadBusinessById(id: String, callBack: (Business?) -> Unit = {}) {
        getBusinessById(id) { busines ->
            if (busines != null) {
                callBack(busines)
                UserDefaults.shared()
                    .store("selected_business", jsonDecoder.encodeToString(busines))
                scope.launch {
                    repository.selectedLiveData.emit(busines)
                }
            }
        }
    }

    fun loadBusinessBy(number: Long) {
        val selectedFromStorage = UserDefaults.shared().retrieve("selected_business")
        if (selectedFromStorage.isNotEmpty()) {
            val bus: Business = jsonDecoder.decodeFromString(selectedFromStorage)
            if (bus.BusinessNumber == number) {
                scope.launch {
                    repository.selectedLiveData.emit(bus)
                }
            } else {
                getBusinessByNumber(number) { busines ->
                    if (busines != null) {
                        UserDefaults.shared()
                            .store("selected_business", jsonDecoder.encodeToString(busines))
                        scope.launch {
                            repository.selectedLiveData.emit(busines)
                        }
                    }
                }
            }
        } else {
            getBusinessByNumber(number) { busines ->
                if (busines != null) {
                    UserDefaults.shared()
                        .store("selected_business", jsonDecoder.encodeToString(busines))
                    scope.launch {
                        repository.selectedLiveData.emit(busines)
                    }
                }
            }
        }
    }

    fun getBusinessByNumber(number: Long, callBack: (Business?) -> Unit) {
        retrieveFromDb(number, callBack)
        val request = RetrieveSingleBusinessRequest(
            number = number
        )
        startLoading()
        BusinessNetwork().retrieveSingleBusiness(request) {
            stopLoading()
            if (!it?.payload?._id.isNullOrEmpty()) {
                DatabaseCollection().insert(data = it.payload, Business.serializer())
                callBack(it.payload)
            } else {
                callBack(null)
            }
        }
    }

    private fun retrieveFromDb(id: String, callBack: (Business?) -> Unit) {
        scope.launch {
            DatabaseCollection().findOne(id, Business.serializer()) {
                callBack(it)
            }
        }
    }

    private fun retrieveFromDb(number: Long, callBack: (Business?) -> Unit) {
        scope.launch {
            DatabaseCollection().findOne(number.toString(), Business.serializer()) {
                callBack(it)
            }
        }
    }

    fun setMyBusiness(business: Business) {
        scope.launch {
            repository.myBusinessLiveData.emit(business)
            delay(500)
            BusinessConfigViewModel().fetchBusinessConfig()
        }
        val businessString = jsonDecoder.encodeToString(Business.serializer(), business)
        UserDefaults.shared().store(KeyConstant.myBusiness, businessString)
    }

    fun setSelectedBusiness(business: Business) {
        scope.launch {
            repository.selectedLiveData.emit(business)
            BusinessConfigViewModel().fetchBusinessConfig()
        }
        if(business._id.contains("[")){
            business._id = ""
        }else{
            val businessString = jsonDecoder.encodeToString(business)
            UserDefaults.shared().store(KeyConstant.selectedBusiness, businessString)
        }
    }

    fun setSelectedStore(business: Business) {
        scope.launch {
            repository.selectedLiveData.emit(business)
        }
        if(business._id.contains("[")){
            business._id = ""
        }else{
            val businessString = jsonDecoder.encodeToString(business)
            UserDefaults.shared().store(KeyConstant.selectedBusiness, businessString)
        }
    }

    @OptIn(ExperimentalTime::class)
    fun createNewBusiness(businessType: BusinessType?, coordinate:ArrayList<Double>, completion: (Business?) -> Unit) {
        val userId = AuthHandler.shared().UserID
        val unique = Clock.System.now().epochSeconds
        createBusiness.value.Address.UserID = userId

        if (!businessType?._id.isNullOrEmpty() && createBusiness.value.Name.isNotEmpty() && createBusiness.value.EmailID.isNotEmpty()) {
            startLoading()
            createBusiness.value.Location =
                LocationCoordinate(
                    coordinate = coordinate,
                )
            if (createBusiness.value.Location.coordinate.count() == 2) {
                createBusiness.value.Location.latitude =
                    createBusiness.value.Location.coordinate.first()
                createBusiness.value.Location.longitude =
                    createBusiness.value.Location.coordinate.last()
                createBusiness.value.Address.Location = createBusiness.value.Location
            }
            createBusiness.value.Address.UserID = userId
            createBusiness.value.Address.UniqueId = unique
            val request = CreateBusinessRequest(
                businessTypeID = businessType._id,
                UserID = userId,
                UserName = AuthHandler.shared().userName,
                MobileNumber = createBusiness.value.MobileNumber,
                dialCode = createBusiness.value.DialCode,
                countryCode = createBusiness.value.CountryCode.uppercase(),
                email = createBusiness.value.EmailID,
                Address = createBusiness.value.Address,
                name = createBusiness.value.Name,
                noteOne = createBusiness.value.noteOne,
                noteTwo = createBusiness.value.noteTwo
            )
            BusinessNetwork().create(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    val allBusiness = repository.allBusiness.value.toMutableList()
                    allBusiness.add(it.payload!!)
                    scope.launch {
                        repository.allBusinessLiveData.emit(allBusiness)
                        completion(it.payload)
                    }
                }
            }
        } else {
            completion(null)
        }
    }

    fun update(business: Business,coordinate:ArrayList<Double> , completion: (Business?) -> Unit) {
        if (business._id.isNotEmpty() && business.Name.isNotEmpty() && business.EmailID.isNotEmpty()) {
            startLoading()
            createBusiness.value.Location =
                LocationCoordinate(
                    coordinate = coordinate,
                )
            if (createBusiness.value.Location.coordinate.count() == 2) {
                createBusiness.value.Location.latitude =
                    createBusiness.value.Location.coordinate.first()
                createBusiness.value.Location.longitude =
                    createBusiness.value.Location.coordinate.last()
                createBusiness.value.Address.Location = createBusiness.value.Location
            }
            createBusiness.value.Address.UserID = UserID
            val request = UpdateBusinessRequest(
                business._id,
                business.MobileNumber,
                business.DialCode,
                business.EmailID,
                business.Name,
                business.Address,
            )
            BusinessNetwork().update(request) {
                stopLoading()
                if (it?.payload != null && it.payload!!._id.isNotEmpty()) {
                    val allBusiness = repository.allBusiness.value.toMutableList()
                    allBusiness.add(it.payload!!)
                    scope.launch {
                        repository.allBusinessLiveData.emit(allBusiness)
                        completion(it.payload)
                    }
                }
            }
        } else {
            completion(null)
        }
    }

    fun updateAddress(
        address: Address, onSuccess: (String) -> Unit, onError: (String) -> Unit
    ) {
//        val request = JSONObject()
//        val user = FriendlyUser()
//        val unixTime = System.currentTimeMillis()
//        request.put(KeyConstant.UserID, user._id)
//        request.put(KeyConstant.address, Gson().toJsonTree(address))
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        request.put(KeyConstant.uniqueId, unixTime)
//        if (selectedBusiness.value != null) {
//            request.put(
//                KeyConstant.BusinessID,
//                selectedBusiness.value._id
//            )
//        }
//        Network.shared().updateAddress(request, { payload ->
//            val businessToUpdate = selectedBusiness.value
//            businessToUpdate.Address = Gson().fromJson(payload.toString(), Address::class.java)
//            businessToUpdate.let { insertDatabase(it) }
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                payload?.let { onSuccess("Updated") }
//            }
//        }, {
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                onError("Updated")
//            }
//        }
//        )
    }

//    fun updateInfo(
//        business: Business, onSuccess: (String) -> Unit, onError: (String) -> Unit
//    ) {
//        val request = JSONObject(Gson().toJson(business))
//        Network.shared().update(request, { payload ->
//            payload?.let {
//                insertDatabase(
//                    Gson().fromJson(
//                        payload.toString(),
//                        Business::class.java
//                    )
//                )
//            }
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                payload?.let { onSuccess("Updated") }
//            }
//        }, { msg ->
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                msg?.let { onError(it) }
//            }
//        }
//        )
//    }


    fun insertDatabase(business: Business) {
        scope.launch {
//            DatabaseHandler.shared().database.businessDao().insert(business)
        }
    }

    fun removeBusinessFromDatabase(id: String) {
        scope.launch {
//            DatabaseHandler.shared().database.businessDao().delete(id)
        }
    }

    fun clearAll() {
        scope.launch {
//            DatabaseHandler.shared().database.businessDao().clearAll()
        }
    }

    fun deleteBusiness(
        business: Business
    ) {
//        val request = JSONObject()
//        val user = FriendlyUser()
//        request.put(KeyConstant.UserID, user._id)
//        request.put(KeyConstant._id, business._id)
//        if (BusinessTypeHandler.shared().repository.businessType != null) {
//            request.put(
//                KeyConstant.businessTypeID,
//                BusinessTypeHandler.shared().repository.businessType!!._id
//            )
//        }
//        SocketService.shared().send(SocketEvent.DELETE_BUSINESS, request)
    }

    fun findBusiness(dialCode: String, mobile: String, callBack: (List<Business>) -> Unit) {
        startLoading()
        val request = FindBusinessRequest(
            "",//UserID as null
            mobile,
            dialCode
        )
        scope.launch {
            BusinessNetwork().findBusiness(request) {
                stopLoading()
                if (it?.payload?.isNotEmpty() == true) {
                    scope.launch {
                        repository.addBusinessConnectionSearchResultState.emit(it.payload)
                    }
                    callBack(it.payload)
                } else {
                    scope.launch {
                        repository.addBusinessConnectionSearchResultState.emit(arrayListOf())
                    }
                    callBack(arrayListOf())
                }
            }
        }
    }

    fun findNearby(query: String, locationCoordinate: LocationCoordinate?) {
        loadNearby(query, locationCoordinate)
        var request: FindNearbyBusinessRequest? = null
//        val primaryAddress = AddressHandler.shared().getPrimaryAddressForCustomer()
//        if (locationCoordinate != null) {
//            request = FindNearbyBusinessRequest(
//                AuthHandler.shared().UserID,
//                locationCoordinate.coordinate.first(),
//                locationCoordinate.coordinate.last()
//            )
//        } else if (primaryAddress?.Location != null) {
//            request = FindNearbyBusinessRequest(
//                AuthHandler.shared().UserID,
//                primaryAddress.Location.coordinate.first(),
//                primaryAddress.Location.coordinate.last()
//            )
//        }
        if (request != null) {
            startLoading()
            scope.launch {
                BusinessNetwork().findNearby(request) {
                    if (it?.payload?.isNotEmpty() == true) {
                        DatabaseCollection().insertAll(it.payload, Business.serializer())
                        stopLoading()
                        loadNearby(query, locationCoordinate)
                    } else {
                        stopLoading()
                        loadNearby(query, locationCoordinate)
                    }
                }
            }
        }
    }

    fun loadNearby(query: String, locationCoordinate: LocationCoordinate?) {
//        BusinessDatabaseTable().findNearby(query, locationCoordinate) { result ->
//            scope.launch {
//                repository.nearbyBusinessSearchResultState.emit(result)
//                repository.nearbyBusinessState.emit(result)
//            }
//        }
    }

    @OptIn(ExperimentalResourceApi::class)
    fun loadSelectedStore(bus: Business, callBack: (Business?) -> Unit) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            setSelectedBusiness(business = bus)
            setSelectedStore(business = bus)
            MediaFileViewModel().retrieveForBusiness(bus._id)
            callBack(bus)
        }
    }
}